Object.defineProperty(exports,"__esModule",{value:true});exports.DEFAULT_COLOR=void 0;var DEFAULT_COLOR=exports.DEFAULT_COLOR='#0E3355';